// extracted by mini-css-extract-plugin
module.exports = {"close-icon":"LoginHeader_close-icon__10l5a","title":"LoginHeader_title__223Ui"};